import CustomerRefundShipmentsApiV2 from 'api/v2/admins/customer-refund-shipments-api-v2'
import CustomerRefundsApiV2 from 'api/v2/admins/customer-refunds-api-v2'
import TitlePage from 'components/atoms/title-page'
import DataTable from 'components/organisms/data-table'
import customerRefundShipmentTableColumns from 'domains/customer-refund-shipment/molecules/table-columns'
import PropTypes from 'prop-types'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useHistory } from 'react-router'
import { Badge, Button, Card, CardHeader } from 'reactstrap'


const propTypes = {
  pageUtils: PropTypes.shape({
    setAlertMsg    : PropTypes.func,
    setApiErrorMsg : PropTypes.func
  })
}

const defaultProps = {
  pageUtils: {
    setAlertMsg    : () => {},
    setApiErrorMsg : () => {}
  }
}

const CustomerRefundShipmentListPage = ({ pageUtils }) => {
  const [ refundShipments, setRefundShipments ] = useState([])
  const [ pagination, setPagination ]           = useState({})
  const [ isLoading, setIsLoading ]             = useState(false)
  const [ shippableCount, setShippableCount ]   = useState(0)

  const history = useHistory()

  const handleFetchRefundShipments = async (tableState) => {
    setIsLoading(true)

    await CustomerRefundShipmentsApiV2.get({ tableState })
      .then((response) => {
        setRefundShipments(response.data.refund_shipments)
        setPagination(response.data.meta)
      })
      .catch((error) => pageUtils.setApiErrorMsg(error.response.data))
      .finally(() => setIsLoading(false))
  }

  const handleClickNew = () => {
    history.push({
      pathname: 'shipments/create'
    })
  }

  // Goes to Refund Request Return Shipment Detail Page when clicking on the row button
  const handleClickDetail = useCallback((datum) => {
    const id = datum.id
    history.push({
      pathname : `shipments/${id}`,
      state    : {
        tracking_no: datum.tracking_no
      }
    })
  }, [ history ])


  const columns = useMemo(() => (
    customerRefundShipmentTableColumns({ handleClickDetail })
  ), [ handleClickDetail ])


  useEffect(() => {
    setIsLoading(true)
    CustomerRefundsApiV2.shippable({})
      .then((response) => {
        setShippableCount(response.data.meta.total_count)
      })
      .catch((error) => {
        pageUtils.setApiErrorMsg(error.response.data)
      })
      .finally(() => setIsLoading(false))
  }, [ pageUtils ])

  return (
    <>
      <TitlePage mainTitle='Customer Refund Shipment' subTitle='List Page' />

      <Card>
        <CardHeader className='font-weight-bold'>
          <div className='float-right'>
            <Badge color="primary" className="mr-1">
              { shippableCount } request can be return
            </Badge>
            <Button
              className='float-right'
              color='primary'
              onClick={ handleClickNew }
              text='NEW'
              disabled={ shippableCount < 1 || isLoading }
            >
              New
            </Button>
          </div>
        </CardHeader>

        <DataTable
          data={ refundShipments }
          pagination={ pagination }
          columns={ columns }
          onFetchData={ handleFetchRefundShipments }
          isLoading={ isLoading }
        />
      </Card>
    </>
  )
}

CustomerRefundShipmentListPage.propTypes    = propTypes
CustomerRefundShipmentListPage.defaultProps = defaultProps

export default CustomerRefundShipmentListPage
